// extracted by mini-css-extract-plugin
export default {"container":"Plots_container__86VAw","new":"Plots_new__eMRir","link":"Plots_link__uqMOi","textbox":"Plots_textbox__v8Agl","tooltip":"Plots_tooltip__cyP24"};